import script from "./LoginInfoPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginInfoPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__